/* istanbul ignore file */

/**
 *
 * Asynchronously loads the component for CreateEditScopePage
 *
 */

import { lazyLoad } from 'utils/loadable';

const CreateEditScopePage = lazyLoad(
  () => import('./index'),
  module => module.CreateEditScopePage,
);

export default CreateEditScopePage;
